module.exports = __webpack_public_path__ + "assets/retina_CircleTangentPPLDetailed.472c7125d4cab6a5f268fc830003f63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleTangentPPLDetailed.png
// module id = 651
// module chunks = 0